// extracted by mini-css-extract-plugin
module.exports = {"attention":"bn_fN"};